<script lang="ts">
    
    import { derived, get, readable } from "svelte/store";
    import type { Readable, Writable } from "svelte/store";
    import type { ReadableStore } from "../Model/ReadableStore";
    import type { WritableStore } from "../Model/WritableStore";

    type Store = WritableStore | ReadableStore | Writable<any> | Readable<any>;

    export let store: Store | Store[];

    let value: Readable<any>;

    $: setupStore(store);

    function setupStore(store: Store | Store[]): void {
        if (Array.isArray(store)) {
            value = derived(store, values => values);
        } else {
            value = readable(get(store), set => store.subscribe(set));
        }
    }

</script>

<slot value={$value}>{$value}</slot>
